import { IFormElementProperties } from '@vfde-brix/ws10/form-element';
import {
    Address,
    toAddressString,
} from '@vfde-sails/avc-core';

/**
 * Returns props to update for multiple address FormElement component
 *
 * @param addresses - Addresses for the user to choose from
 */
export const getMultipleAddressSelectProps = (addresses: Address[]): Partial<IFormElementProperties> => ({
    containerInput: {
        items: addresses.map((address, index) => ({
            stdOptionLabel: toAddressString(address, true),
            stdOptionValue: index.toString(),
        })),
    },
});
